// Simple LRU cache policy for use with the persistent IndexedDB cache

// const {log} = console;

export const makeLRUCachePolicy = capacity => {
	let lruArray = [];

	const initLRU = all => {
		const entries = Object.values(all);
		// log(`entries=${JSON.stringify(entries, null, 2)}`);

		// Sort all by timestamp in newest first order
		entries.sort((a, b) => {
			const dateA = a.cachePolicyState.lastAccessed;
			const dateB = b.cachePolicyState.lastAccessed;
			// log(`dateB=${dateB}`);
			// log(`dateA=${dateA}`);
			const result = dateB - dateA;
			// log(`result=${result}`);

			return result;
		});
		// log(`sorted=${JSON.stringify(all, null, 2)}`);

		for (const entry of entries) lruArray.push(entry.key);

		// log(`lruArray=${JSON.stringify(lruArray, null, 2)}`);
	};

	const evict = capacity => {
		const len = lruArray.length;
		if (len > capacity) {
			// Even if this is over by more than one, we trim it to capacity
			const keysToDelete = lruArray.splice(capacity, len - capacity);
			// log(`evict(): keysToDelete=${JSON.stringify(keysToDelete, null, 2)}`);
			return keysToDelete;
		}

		return [];
	};

	// Bump key to the front and evict if we are over capacity
	const updateLRU = key => {
		const index = lruArray.findIndex(k => k === key);
		let keysToDelete;
		if (index === -1) {
			// Not found, so first evict to make space, then prepend the new key
			keysToDelete = evict(capacity - 1);
		} else {
			keysToDelete = evict(capacity);
			lruArray.splice(index, 1);
		}
		lruArray = [key, ...lruArray];
		// log(`updateLRU(): lruArray=${JSON.stringify(lruArray, null, 2)}`);

		const result = {keysToDelete, state: {lastAccessed: new Date()}};
		// log(`updateLRU(): result=${JSON.stringify(result, null, 2)}`);
		return result;
	};

	const deleteFromLRU = key => {
		const index = lruArray.findIndex(k => k === key);
		if (index === -1) return;

		lruArray.splice(index, 1);
	};

	const clearLRU = () => {
		lruArray = [];
	};

	return {
		capacity,
		onInit: initLRU,
		onHit: updateLRU,
		onSet: updateLRU,
		onDelete: deleteFromLRU,
		onClear: clearLRU
	};
};
